import { type JSX, type ParentProps, createSignal } from 'solid-js'
import { Portal } from 'solid-js/web'
import { Popover } from '../ui/popover'
import type { Tooltip } from '../ui/tooltip'
import { debounce } from '@solid-primitives/scheduled'

export const AppTooltip = (
	props: ParentProps<Tooltip.RootProps & { content: JSX.Element; className?: string, delay?: number }>,
) => {
	const { content, children, className, delay, ...rest } = props
	const [isOpen, setIsOpen] = createSignal(false)

  const setIsOpenDebounced = debounce(setIsOpen, (delay || 100))


	return (
		<Popover.Root
			{...rest}
			open={isOpen()}
			positioning={{
				fitViewport: true,
				placement: 'top',
			}}
		>
			<Popover.Anchor
				class={className}
				onMouseLeave={() => setIsOpenDebounced(false)}
				onMouseEnter={() => setIsOpenDebounced(!isOpen())}
			>
				{props.children}
			</Popover.Anchor>
			<Portal>
				<Popover.Positioner  zIndex={isOpen() ? '9999!important' : ''}>
					<Popover.Content
						outline="none"
						fontSize="xs"
						p="2"
					>
						{props.content}
					</Popover.Content>
				</Popover.Positioner>
			</Portal>
		</Popover.Root>
	)
}
